export const lifecycleEventTypes = {
  //beforeLoad: "DOMContentLoaded",
  load: "load", 
  beforeUnload: "beforeunload",
  unload: "unload",
}